import { useHarnessStore } from '@/store/useHarnessStore';
import { ExcitationProfileView } from './ExcitationProfileView';

/**
 * Live-harness Excitation Profile panel: binds {@link ExcitationProfileView} to the store's
 * Measurements and selection. The review view (Story 3.1) reuses `ExcitationProfileView` directly
 * with fetched data.
 */
export function ExcitationProfilePanel() {
  const measurements = useHarnessStore((s) => s.measurements);
  const selectedMeasurementIds = useHarnessStore((s) => s.selectedMeasurementIds);

  return (
    <ExcitationProfileView measurements={measurements} selectedIds={selectedMeasurementIds} />
  );
}
